import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import client from 'api/client'
import { enableBodyScroll } from 'body-scroll-lock'

import * as Actions from 'redux/actions'
import store from 'redux/store'

type OnboardingType = 'redirect_modal'
const KEY_PREFIX = 'show_onboarding_'

export const exitOnboarding = (type: OnboardingType) => {
  enableBodyScroll(document.body)
  client.updateUser({ meta: { [`${KEY_PREFIX}${type}`]: false } }).then(res => {
    if (res.type === SUCCESS_RESPONSE_TYPE) {
      store.dispatch(
        Actions.authMerge({
          auth: {
            meta: res.data.user.meta,
          },
        }),
      )
    }
  })
}
